import { Typography } from "@mui/material";
import noDataIcon from "assets/admin/no_data.png";
import classes from "./style.module.scss";

export const Empty = ({ className = "", objectName = "رکوردی" }) => {
  return (
    <div className={`${classes.wrapper} ${className}`}>
      <img src={noDataIcon} alt="no-data-icon" width={75} height={75} />
      <Typography variant="subtitle1">{objectName} یافت نشد</Typography>
    </div>
  );
};
